<template>
  <v-col cols="12">
    <v-data-table
      :headers="headers"
      :items="quotationData"
      class="elevation-1"
      :loading="loading"
      :search="search"
      fixed-header
      height="70vh"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider></v-toolbar
      ></template>
    </v-data-table>
  </v-col>
</template>

<script>
import axios from "axios";
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "QuotationReport",
  components: {},
  data: () => ({
    loading: false,
    quotationData: [],
    roles: null,
    headers: [
      { text: "Product", value: "product", width: "10%" },
      { text: "Variant", value: "variant", width: "15%" },
    ],
    search: null,
    test: [],
  }),
  methods: {
    async loadData() {
      this.loading = true;
      this.quotationData = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "quotation-report-loadData"
      );

      if (currentSession.accessToken) {
        this.userId = currentSession.username;
        await axios
          .get(window.domain + "reports/fulfillment?report_type=quotation", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            this.quotationData = response.data.data;

            for (var col in response.data.data[0]) {
              if (col != "product" && col != "variant") {
                var item = {
                  text: col,
                  value: col,
                };
                this.headers.push(item);
              }
            }

            this.loading = false;
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>